import PhotoSwipeLightbox from "photoswipe-lightbox";
import PhotoSwipe from "photoswipe";
import { initProductForm } from "@theme/cart";
import { updateDomComponent } from "@theme/critical";

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.#abortController = new AbortController();

    if (this.closest(".product-box")) {
      this.submitButton =
        this.closest(".product-box").querySelector(`[type="submit"]`);
     }

    this.prId = this.closest(".product-box").querySelector(`input[name="id"]`)
  }

  #abortController;

  connectedCallback() {
    const signal = this.#abortController.signal;

    const options = this.querySelectorAll(
      'input[type="radio"][name^="option["]',
    );

    if (!options.length) {
      return;
    }

    const getChecked = () => {
      const checked = Array.from(options).filter((o) => o.checked);
      return checked.map((o) => o.value).join(",");
    };

    /**
     * Aggiorna lo stato del pulsante di submit in base al variant selezionato
     * @param {HTMLInputElement} variant
     */
    const updateSubmitButton = (variant) => {
      if (!this.submitButton) {
        return;
      }

      const availableText =
        this.submitButton.dataset.availableText || "Add to cart";
      const unavailableText =
        this.submitButton.dataset.unavailableText || "Notify Me";
      const selectText =
        this.submitButton.dataset.selectText || "Select variant";

      const updateText = (text) => {
        const textSpan = this.submitButton.querySelector(".btn-text");
        if (textSpan) {
          textSpan.textContent = text;
        } else {
          this.submitButton.value = text;
        }
      };

      const updateIcons = (mode) => {
        const cartIcon = this.submitButton.querySelector('[data-icon="cart"]');
        const bellIcon = this.submitButton.querySelector('[data-icon="bell"]');
        const isNotify = mode === "notify";
        if (cartIcon) cartIcon.toggleAttribute("hidden", isNotify);
        if (bellIcon) bellIcon.toggleAttribute("hidden", !isNotify);
      };

      const updateClass = (mode) => {
        const isNotify = mode === "notify";
        this.submitButton.classList.toggle("klaviyo-bis-trigger", isNotify);
        this.submitButton.classList.toggle("btn-add-to-cart", !isNotify);
        updateIcons(mode);
      };

      if (!variant) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute("aria-disabled", "true");
        updateText(selectText);
        updateClass("select");
        return;
      }

      this.submitButton.disabled = false;
      this.submitButton.removeAttribute("aria-disabled");

      if (variant.disabled) {
        updateText(unavailableText);
        updateClass("notify");
        return;
      }

      const isPreorder = this.submitButton.dataset.preorder === "true";
      const preorderText =
        this.submitButton.dataset.preorderText || availableText;
      updateText(isPreorder ? preorderText : availableText);
      updateClass(isPreorder ? "preorder" : "atc");
    };

    /**
     * Aggiorna l'URL e i contenuti in pagina prodotto con il variant selezionato
     * @param {HTMLInputElement} variant
     */
    const updatePage = async (variantId) => {
      if (!variantId) return;

      const url = new URL(window.location.href);

      // Se siamo nella pagina prodotto ufficiale, aggiorniamo URL e prezzi
      if (
        document.body.classList.contains("template-product") &&
        this.closest(".product-wrapper")
      ) {
        url.searchParams.set("variant", variantId);
        window.history.pushState({ variantId: variantId }, "", url.toString());

        await updateDomComponent(
          [".product-wrapper .product-price"],
          ["product"],
          `${url.toString()}${url.search ? "&" : "?"}variant=${variantId}`,
          { mode: "outerHtml", returnDocument: false },
        );
      }

      // Lanciamo l'evento con bubbles: true per permettere ai genitori (come QuickBuy) di intercettarlo
      this.dispatchEvent(
        new CustomEvent("variant-change", {
          bubbles: true,
          composed: true,
          detail: { variantId },
        }),
      );
    };

    /** const selection = getChecked();
    const initialVariant = this.querySelector(
      `input[name="id"][data-options="${selection}"]`,
    );
    updateSubmitButton(initialVariant); */

    options.forEach((o) => {
      o.addEventListener(
        "change",
        () => {
          const selection = getChecked();

          const variant = this.querySelector(
            `input[data-options="${selection}"]`,
          );

          updateSubmitButton(variant);

          if (variant) {
            this.prId.value = variant.value;
            updatePage(variant.value);
          }
        },
        { signal },
      );
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }
}

if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}

function initPhotoSwipe() {
  const lightbox = new PhotoSwipeLightbox({
    gallery: "#pdp-gallery",
    children: "a.carousel-item",
    pswpModule: PhotoSwipe,
  });
  lightbox.init();
}

function initPrefetchColorVariants() {
  const colorLinks = document.querySelectorAll(".js-color-variant-link");

  const prefetchUrl = (url) => {
    if (!document.querySelector(`link[rel="prefetch"][href="${url}"]`)) {
      const linkEl = document.createElement("link");
      linkEl.rel = "prefetch";
      linkEl.href = url;
      linkEl.as = "document";
      document.head.appendChild(linkEl);
    }
  };

  colorLinks.forEach((link) => {
    const url = link.dataset.prefetchUrl;
    if (!url) return;

    link.addEventListener("mouseenter", () => prefetchUrl(url), { once: true });

    link.addEventListener("touchstart", () => prefetchUrl(url), {
      passive: true,
      once: true,
    });
  });
}

function initPdp() {
  initPhotoSwipe();
  document.querySelectorAll("form[data-type='add-to-cart-form']").forEach((form) => {
    initProductForm(form);
  });
  initPrefetchColorVariants();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdp, { once: true });
} else {
  initPdp();
}
